import { render, staticRenderFns } from "./ot-documents-filter.vue?vue&type=template&id=4fdc3528&scoped=true&"
import script from "./ot-documents-filter.vue?vue&type=script&lang=ts&"
export * from "./ot-documents-filter.vue?vue&type=script&lang=ts&"
import style0 from "./ot-documents-filter.vue?vue&type=style&index=0&id=4fdc3528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdc3528",
  null
  
)

export default component.exports